import axios from 'axios';
import constants from '../constants';

const POS_PATH = constants.urlPrefix + '/api/pos';

const getToastMenus = (restaurantId) => axios.get(POS_PATH + `/toast/restaurants/${restaurantId}/menus`);
const getToastRestaurants = (email) => axios.get(POS_PATH + '/toast/restaurants', {params: {email}});
const sendEmail = (toastEmail, mhmEmail, siteURL) => axios.get(POS_PATH + '/toast/verification', {params: {toastEmail, mhmEmail, siteURL}});
const verifyUUID = (uuid, toastEmail) => axios.get(POS_PATH + '/toast/verification/confirm', {params: {uuid, toastEmail}});
const isToastLinked = (memberId) => axios.get(POS_PATH + '/toast/verified', {params: {memberId}});
const unlinkToast = (memberId) => axios.get(POS_PATH + '/toast/verification/unlink', {params: {memberId}});
const getCloverRestaurants = () => axios.get(POS_PATH + '/clover/restaurants');
const getCloverMenus = (mid) => axios.get(POS_PATH + '/clover/categories', {params: {mid}});

const getSquareRestaurants = () => axios.get(POS_PATH + '/square/restaurants');
const getSquareLocations = (restaurantId) => axios.get(POS_PATH + '/square/locations', {params: {restaurantId}});
const getSquareMenus = (mid) => axios.get(POS_PATH + '/square/categories', {params: {mid}});

const getTreezRestaurants = () => axios.get(POS_PATH + '/treez/restaurants');
const getTreezMenus = (mid) => axios.get(POS_PATH + '/treez/menus', {params: {mid}});
const verifyTreez = (memberId, locationId, apiKey, dispensaryName) => axios.get(POS_PATH + '/treez/verify', {params: {memberId, locationId, apiKey, dispensaryName}});

const getPopmenuRestaurants = () => axios.get(POS_PATH + '/popmenu/restaurants');
const getPopmenuLocations = (restaurantId) => axios.get(POS_PATH + '/popmenu/locations', {params: {restaurantId}});
const getPopmenuMenus = (restaurantId, locationId) => axios.get(POS_PATH + '/popmenu/menus', {params: {restaurantId, locationId}});

function mapSections(sections, menu, source, locationId, itemLibrary = false) {
  if (!sections || !sections.length) return [];
  const removeInvalid = se => (!!se.items.length || !!se.sections.length) && !se.removed;
  return sections.filter(removeInvalid)
    .map(se => {
      return {
        id: itemLibrary ? se.externalId : se.id,
        name: se.name || 'Group Name',
        description: itemLibrary ? se.note : se.description,
        sections: mapSections(se.sections, menu, source, locationId, itemLibrary),
        items: mapItems(se.items, menu, source, locationId, itemLibrary),
        menuId: itemLibrary ? menu.externalId : menu.id,
        source,
        sequence: se.sequence,
        visible: true
      }
    })
    // run again in case items are no longer available
    .filter(removeInvalid)
}

export function filterMenuItemByLocation(mi, locationId) {
  if (!locationId || mi.availableAtLocations === null || mi.availableAtLocations === undefined) return true;
  return mi.availableAtLocations.split(',').includes(locationId);
}

function mapItems(items, menu, source, locationId, itemLibrary) {
  if (!items || !items.length) return [];
  return items.filter(mi => !mi.removed)
    .filter(mi => filterMenuItemByLocation(mi, locationId))
    .map(mi => {
      return {
        id: itemLibrary ? mi.externalId : mi.id,
        source,
        name: mi.name,
        tag: itemLibrary ? mi.tags : mi.itemTags,
        description: mi.description,
        prices: !!mi.prices?.length ? formatMultiPrices(mi.prices, locationId) : [{size: '', price: formatPrice(mi.price)}],
        modifiers: mapModifiers(mi.modifiers),
        menuId: itemLibrary ? menu.externalId : menu.id,
        sequence: mi.sequence,
        availableAtLocations: mi.availableAtLocations
      }
    })
}

function formatMultiPrices(prices, locationId) {
  prices.forEach(entry => {
    if (entry.locationOverride) {
      const locationOverride = JSON.parse(entry.locationOverride);
      if (locationOverride[locationId]) {
        entry.price = formatPrice(locationOverride[locationId]);
      } else {
      entry.price = formatPrice(entry.price);
      }
    } else {
      entry.price = formatPrice(entry.price);
    }
  });
  return prices.sort((a, b) => a.sequence - b.sequence);
}

function formatPrice(price) {
  if (!price) return '';
  return parseFloat(`${price}`).toFixed(2);
}

function mapModifiers(modifiers) {
  let returnMods = [];
  modifiers.forEach(m => {
    let thisMod = {};
    thisMod.name = m.name;
    thisMod.entries = [];
    m.entries.forEach(e => {
      let thisEntry = {};
      thisEntry.name = e.name;
      thisEntry.price = e.price;
      thisEntry.displayPrice = e.price;
      thisMod.entries.push(thisEntry);
    })
    returnMods.push(thisMod);
  })
  return returnMods;
}

function mapMenu(menu, source, toastLocationName = '', locationId = '', itemLibrary = false) {
  return {
    source,
    name: menu.name,
    sections: mapSections(menu.sections, menu, source, locationId, itemLibrary),
    id: itemLibrary ? menu.externalId : menu.id,
    toastLocationName,
    sequence: menu.sequence,
    visible: true
  }
}

function connectToSquare() {
  const isTestEnv = constants.isTestEnv;
  const baseUrl = isTestEnv ? 'https://connect.squareupsandbox.com' : 'https://connect.squareup.com';
  const clientId = isTestEnv ? 'sandbox-sq0idb-iMRQBK9PoqMnCLFDUxG52A' : 'sq0idp-ZR73v4F9a_ZQMtaz-ahEAA';
  const scope = 'ITEMS_READ,MERCHANT_PROFILE_READ,INVENTORY_READ';
  const state = generateToken();
  window.localStorage.setItem('squareState', state);

  const url = `${baseUrl}/oauth2/authorize?client_id=${clientId}&scope=${scope}&session=false&state=${state}`;
  window.open(url, "_blank");
}

function generateToken(length = 16) {
  const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let password = "";
  for (let i = 0; i < length; i++) {
    password += charset.charAt(Math.floor(Math.random() * charset.length));
  }
  return password;
}

export default {
  getToastRestaurants,
  getToastMenus,
  sendEmail,
  verifyUUID,
  isToastLinked,
  unlinkToast,
  getCloverRestaurants,
  getCloverMenus,
  getSquareRestaurants,
  getSquareLocations,
  getSquareMenus,
  mapMenu,
  getTreezRestaurants,
  getTreezMenus,
  verifyTreez,
  getPopmenuRestaurants,
  getPopmenuMenus,
  getPopmenuLocations,
  connectToSquare
}
